import React, { FC, Fragment, useState } from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import { formatCurrency } from 'utils/format';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';
import OrderPriceSpecDialog from 'components/orders/shared/order-price-spec-dialog.component';

type OrderPriceProps = {
    price: number | null;
    orderId: string;
    currency: string;
};
const OrderPrice: FC<OrderPriceProps> = ({ price, orderId, currency }: OrderPriceProps) => {
    const { t: translate } = useTranslation(['orders']);
    const [priceSpecDialogOpen, setIsPriceSpecDialogOpen] = useState(false);

    return (
        <Fragment>
            {price || price === 0 ? (
                <Box display="flex" alignItems="center">
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsPriceSpecDialogOpen(true);
                        }}
                        aria-label="template"
                        size="small"
                        sx={{ pl: 0 }}
                    >
                        <InfoIcon fontSize="inherit" color="info" />
                    </IconButton>
                    <Typography variant="body2">{formatCurrency(price, currency)}</Typography>
                </Box>
            ) : (
                <Typography variant="body2" color="text.secondary">
                    {translate('orders:NO_PRICE')}
                </Typography>
            )}
            {priceSpecDialogOpen && (
                <OrderPriceSpecDialog
                    open={priceSpecDialogOpen}
                    onClose={() => setIsPriceSpecDialogOpen(false)}
                    orderId={orderId}
                    price={price}
                />
            )}
        </Fragment>
    );
};

export default OrderPrice;
